/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import 'dxpAdministration-mf/styles';
import 'dxpArtificialIntelligence-mf/styles';
import 'dxpComponentService-mf/styles';
import 'dxpConfiguration-mf/styles';
import { AppManager } from 'dxpConsoleCore-mf/Components';
import 'dxpConsoleCore-mf/styles';
import 'dxpContentManagement-mf/styles';
import 'dxpCustomerDataPlatform-mf/styles';
import 'dxpDigitalAssetManagement-mf/styles';
import 'dxpInstanceManagement-mf/styles';
import 'dxpMonitoring-mf/styles';
import 'dxpOptimization-mf/styles';
import { addTranslations } from 'libs/i18n';
import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../../mf-decl.d';
import { ConsoleHost } from './_global/ConsoleHost';
import enUsTranslations from './locales/en-us/translations.json';

addTranslations(enUsTranslations);

// Render
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <AppManager>
    <ConsoleHost />
  </AppManager>,
);
